import { configureStore } from "@reduxjs/toolkit";
import productSlice from "../features/productSlice";
import CategorySlice from "../features/CategorySlice";
import cartSlice from "../features/cartSlice";
import authSlice from "../features/authSlice";
import orderSlice from "../features/orderSlice";
import customerSlice from "../features/customerSlice";
import userSlice from "../features/userSlice";
import checkoutSlice from "../features/checkoutSlice.tsx";



const store = configureStore ({
    reducer: {
        product : productSlice,
        categories : CategorySlice,
        cart: cartSlice,
        auth: authSlice,
        order: orderSlice,
        user: userSlice,
        customer: customerSlice,
        checkout: checkoutSlice

    }
}) 
export  default store